import { useMemo } from 'react'
import { t } from 'i18next'
import {
  ModalHeading,
  ModalDismiss,
  ModalContent,
  Modal,
  ModalHeader,
  ModalFooter,
  Alert
} from '@vtex/shoreline'

import { Button } from '~/components/Buttons'
import { formatDate, formatMoney } from '~/helpers'

import * as S from './styles'

export const DigitalSignageConfirmationModal = ({
  isModalOpen,
  setIsModalOpen,
  formRef,
  isPending,
  isTotalBudgetEditable
}: DigitalSignageConfirmationModalProps) => {
  const formData = useMemo(
    () => formRef?.current?.getData() as CreateDigitalSignageFormData,
    [formRef?.current]
  )

  const totalBudget = useMemo(
    () => formData?.total_budget?.value || formatMoney(0),
    [formData?.total_budget?.value]
  )

  const startDate = useMemo(
    () => formatDate(formData?.start_date || '', undefined, 'DD/MM/YYYY'),
    [formData?.start_date]
  )

  const endDate = useMemo(
    () => formatDate(formData?.end_date || '', undefined, 'DD/MM/YYYY'),
    [formData?.end_date]
  )

  return (
    <Modal
      size="medium"
      open={isModalOpen}
      onClose={() => setIsModalOpen(false)}
    >
      <ModalHeader>
        <ModalHeading
          style={{ fontSize: '1.25rem', fontWeight: 600, margin: 0 }}
        >
          {t('rm:createCampaign')}
        </ModalHeading>
        <ModalDismiss />
      </ModalHeader>
      <ModalContent>
        <Alert variant="warning">
          {t(
            isTotalBudgetEditable
              ? 'rm:campaign.create.Modal.alert.editableTotalBudget'
              : 'rm:campaign.create.Modal.alert.notEditableTotalBudget'
          )}
        </Alert>

        <S.DataContainer>
          <div>
            <p>
              {t('rm:startDate')}: <span>{startDate}</span>
            </p>
            <p>
              {t('rm:endDate')}: <span>{endDate}</span>
            </p>
          </div>

          {isTotalBudgetEditable && (
            <p>
              {t('rm:totalBudget')}: <span>{totalBudget}</span>
            </p>
          )}
        </S.DataContainer>
      </ModalContent>
      <ModalFooter>
        <Button
          template="secondary"
          size="large"
          onClick={() => setIsModalOpen(false)}
        >
          {t('rm:button.Cancel')}
        </Button>
        <Button
          template="primary"
          size="large"
          type="submit"
          loading={isPending}
          onClick={() => {
            formRef.current?.submitForm()
            setIsModalOpen(false)
          }}
        >
          {t('rm:sendForApproval')}
        </Button>
      </ModalFooter>
    </Modal>
  )
}
